export const messages = {
    en: {
        hi: {
            lang_name: 'English',
            areYouSure: '¿Are you sure?',
            book: 'Book',
            yes: 'Yes',
            no: 'No',
            create: 'Create',
            edit: 'Edit',
            delete: 'Delete',
            socialNetworks: 'Social networks',
            siteName: 'Arte-contemporary',
            homeDescription: 'A 3 hectares sculpture park placed in ancient olive groves & a 300 sqm contemporary art gallery in the outskirts of the Ebro Delta',
            loginRegister: 'Login & register',
            name: 'Name',
            surname: 'Surname',
            email: 'Email',
            password: 'Password',
            phone: 'Phone',
            role: 'Role',
            admin: 'Administrator',
            client: 'Client',
            icon: 'Icon',
            save: 'Save',
            roles: 'User roles',
            authors: "Artists",
            socialNetwork: 'Social network',
            socialNetworkFollow: 'Follow on social networks:',
            countries: 'Countries',
            iso2: 'Iso2',
            url: 'URL',
            device_not_suport_uploading: '<p>Your device does not support file uploading.</p>',
            drag_upload_image: 'Drag an image or <br>click here to select a file',
            tap_upload_image: 'Tap here to select a photo <br>from your gallery',
            change_image: 'Change photo',
            remove_image: 'Remove photo',
            select_image: 'Select photo',
            selected_image: '<p>Photo successfully selected!</p>',
            error_filesize: 'The file size exceeds the limit',
            error_filetype: 'This file type is not supported.',
            aspect: 'Landscape/Portrait',
            description: 'Description',
            type: 'Type',
            address: 'Address',
            zip_code: 'Zip Code',
            city: 'City',
            region: 'Region',
            notes: 'Notes',
            user: 'User',
            country: 'Country',
            user_address_details: 'User Address Details',
            userAddresses: 'User Addresses',
            userAddressTypes: 'User Address Type',
            userAddressTypeInvoice: 'Invoice',
            userAddressTypeDelivery: 'Delivery',
            categories: 'Categories',
            category: 'Category',
            artworks: 'Artworks',
            artwork: 'Artwork',
            author: 'Artist',
            authorInfo_1: "Artist's",
            authorInfo_2: 'Information',
            public: 'Is public',
            on_sale: 'On sale',
            taxes: 'Taxes',
            tax: 'Tax',
            percent: 'Percent',
            close: 'Close',
            stock: 'Stock',
            price: 'Price',
            amount: 'Amount',
            image: 'Image',
            holidays: 'Holidays',
            holiday: 'Holiday',
            day_start: 'Day start',
            month_start: 'Month start',
            year_start: 'Year start',
            day_end: 'Day end',
            month_end: 'Month end',
            year_end: 'Year end',
            days_of_week: 'Days of week',
            exceptions: 'Exceptions',
            day: 'Day',
            month: 'Month',
            year: 'Year',
            assistants: 'Assistants',
            date_start: 'Date start',
            date_end: 'Date end',
            time_start: 'Time start',
            time_end: 'Time end',
            users: 'Users',
            without_artworks: 'Without artworks',
            related_artworks: 'Related artworks',
            shoppingCart: 'Shopping cart',
            cartProduct: 'Product',
            cartPrice: 'Price',
            cartQty: 'Quantity',
            cartSubTotal: 'Subtotal',
            cartCheckout : 'Checkout',
            cartComplete: 'Order complete',
            cartTotals: 'Cart totals',
            cartShipping: 'Shipping',
            cartProceed: 'Proceed to checkout',
            cartCouponCode: 'Coupon Code',
            cartCoupon: 'Apply coupon',
            cartUpdate: 'Update cart',
            cartTax: 'Tax',
            cartTotalTax: 'Total Taxes',
            cartTotTot: 'Total',
            cartBooking: 'Booking',
            cartPlaces: 'place(s)',
            addShoppingCart: 'Add to cart',
            places_available: '{places} places available',
            chkoutDetails: 'Billing Details',
            chkoutName: 'Name',
            chkoutCompany: 'Company Name',
            chkoutCountry: 'Country/Region',
            chkoutCity: 'Town/City',
            chkoutZIP: 'ZIP',
            chkoutEmail: 'Email Address',
            chkoutPhoneNumber: 'Phone Number',
            chkoutAccount: 'Create an account?',
            chkoutNotes: 'Order Notes',
            chkoutNotes2: 'Notes about you order e.g. special notes for delivery',
            chkoutSelAddress: 'Select billing address',
            chkoutAddress: 'Street Address',
            chkoutSelShipAddress: 'Select shipping address',
            chkoutShipAddress: 'Shipping Address',
            chkoutLogin: 'Returning customer?',
            chkYourOrder: 'Your order',
            chkoutResume: 'Product summary',
            chkoutShipType: 'Shipping',
            chkoutPayment: 'Payment Methods',
            chkoutPlaceOrder: 'Place Order',
            chkoutPassword: 'Password',
            chkoutRemember: 'Remember Me',
            chkoutForgot: 'Forgot Password?',
            chkoutOr: 'or',
            chkoutFacebook: 'Login With Facebook',
            chkoutRegister: 'Register',
            chkoutConfirm: 'Password confirmartion',
            chkoutModalShipTitle: 'Shipping Address',
            chkoutModalInvoiceTitle: 'Add Invoice Address',
            chkoutModalInvTitle: 'Invoice Address',
            chkoutInvoiceMandatory: 'Invoice address is required',
            chkoutDeliveryMandatory: 'Delivery address is required',
            chkoutNews: 'I want to receive news Arte-Contemporary news, events and special offers',
            chkoutWithTax: '(IVA included)',
            chkoutWithoutTax: '(IVA not included)',
            cartAction: 'Action',
            cartAlertTitle: 'Update Cart',
            cartAlertText: 'Update Successful',
            cartAlertCheck: 'Go to payment',
            cartAlertCancel: 'Back to cart',
            delivery_address: 'Delivery address',
            delivery_zip: 'Zip code',
            delivery_city: 'City',
            delivery_region: 'Region',
            delivery_notes: 'Notes',
            tickets: 'Tickets',
            ticket: 'Ticket',
            book_your_tickets: 'Book your tickets',
            plan_visit_opening_times: 'Bookings',
            find_us: 'How to find us?',
            personalizables: 'Personalized',
            rapita_ebro_delta: 'La Ràpita & the Ebro Delta',
            reservations_text: 'Ticket Reservation Text',
            inicio_text: 'Home Section',
            RapitaEbroDelta: 'La Ràpita & the Ebro Delta',
            about: 'Who is behind this project?',
            video_tour: 'Video Tour',
            sculpture_park_gallery: 'About the sculpture park & the gallery',
            SulptureParkGallery: 'About the sculpture park & the gallery',
            exhibitions_events: 'Exhibitions & Events',
            current_exhibitions_cultural_program: 'Exhibitions & Cultural program',
            about_the_artists: 'About the artists',
            'purchasing_arte-pieces': 'Gallery Shop',
            private_corporate_hire: 'Private & corporate hire',
            profilePageTitle: 'User Profile',
            profileMenuGeneralData: 'My Profile',
            profileMenuAddresses: 'Addresses',
            profileMenuShipping: 'My shipping addresses',
            profileMenuInvoices: 'My invoice addresses',
            profileFormName: 'Full name',
            profileFormEmail: 'Email',
            profileFormPhone: 'Phone number',
            profileFormActualPass: 'Current Password',
            profileFormPassword: 'New Password',
            profileFormConfirm: 'Confirm password',
            profileFormSave: 'Save',
            profileShipAddress: 'Shipping Addresses',
            profileInvoiceAddress: 'Invoice Addresses',
            profileEdit: 'Edit',
            profileDelete: 'Delete',
            profileAddAddress: 'Add Address',
            profileTabProfile: 'My Profile',
            profileTabShipping: 'My Delivery Addresses',
            profileTabInvoice: 'My Invoice Addresses',
            profileTabPassword: 'Change Password',
            profileTabMyInvoices: "My shopping's",
            profileInvoiceNumber: 'Invoice number',
            profileInvoiceDate: 'Date',
            profileInvoiceTotal: 'Total',
            profileInvoiceDownload: 'Download',
            confirm_password: 'Confirm password',
            confirm_shopping_cart: 'Activate "Confirm cart" in the purchase process',
            home:'Home',
            contactTitle: 'Contact Us',
            contactName: 'Full Name',
            contactEmail: 'Email Address',
            contactPhoneNumber: 'Telephone number',
            contactSubject: 'Subject',
            contactMessage: 'Message',
            contactSend: 'Send Message',
            contactSuccess: 'Success!',
            contactSuccessMsg: 'Your message has been sent to us.',
            contactError: 'Error!',
            contactErrorMsg: 'There was an error sending your message.',
            contactHours: 'Business Hours',
            contactHoursDays: 'Wednesday to Sunday from 9:00h to 14:00h',
            contactTouch: 'Get in Touch',
            contactTouchMsg: 'Contact us, we are at your disposal for any doubt or question you may have.',
            contactUs: 'Contact Us',
            footerMap: 'View our location',
            footerCopy: 'All Rights Reserved.',
            userProfile: 'User Profile',
            Contact: 'Contact Us',
            UserProfile: 'User Profile',
            CheckoutCart: 'Checkout',
            login_or_register: 'Login or register',
            date: 'Date',
            view_shoppingcart: 'View Shopping Cart',
            checkout: 'Checkout',
            contactUsTitle: 'Contact us',
            shoppingCarts: 'Shopping Carts',
            order_number: 'Order Number',
            status: 'Status',
            booking: 'Booking',
            bookings: 'Bookings',
            items: 'Items',
            read_more: 'Read more',
            processing: 'Processing',
            new: 'New',
            confirmed: 'Confirmed',
            paid: 'Paid',
            cancelled: 'Cancelled',
            abandoned: 'Abandoned',
            make_invoice: 'Make invoice',
            invoice_address: 'Invoice address',
            view_all: 'View all',
            share: 'Share',
            artworkDetails: 'Artwork Details',
            time: 'Time',
            admin_panel: 'Admin Panel',
            unknown_error: 'Unknown error',
            user_password_error: 'Wrong email or password',
            thank_you_order_received: 'Thank you! Order received.',
            total: 'Total',
            payment_method: 'Payment method',
            credit_card: 'Credit Card',
            your_order: 'Purchase summary',
            product: 'Product',
            subtotal: 'Subtotal',
            shipping: 'Shipping',
            shippingFree: 'Free shipping',
            CompleteCart: 'Order completed',
            personal_data_usage: 'Your personal data will be used to support your experience throughout this website, to manage access to your account, and for other purposes described in our <a href="#" class="text-decoration-none">privacy policy</a>.',
            register: 'Register',
            contactHoursTime: '9:00AM - 8:00PM',
            location: '40°38\'07.2"N 0°35\'03.2"E, Sant Carles de la Ràpita, Tarragona',
            info_mail: 'info@arte-contemporary.eu',
            corporate_mail: 'corporate@arte-contemporary.eu',
            starterPages: 'Starter Pages',
            activePage: 'Active Page',
            inactivePage: 'Inactive Page',
            simpleLink: 'Simple Link',
            remember_me: 'Remember me',
            forgot_password: 'Forgot password',
            login: 'Login',
            password_confirmation: 'Password confirmation',
            dates_ft: 'Visit from {from} to {to}',
            view_more: 'View more',
            exhibitions: 'Exhibitions',
            plan_visit: 'Plan your visit',
            rentParkTitle: 'Do you want to organize a memorable and unique Event? ',
            PDFinvoice: 'Invoice',
            phone_number: 'Phone Number',
            website: 'Website',
            start: 'Start',
            end: 'End',
            active: 'Active',
            timeSlots: 'Time slots',
            timeSlot: 'Time slot',
            rent_park: 'Private & Corporate hire',
            results_not_found: 'No results found',
            go_back: 'Go back',
            add: 'Add',
            gdpr_accept_policy: 'I have read and accept the <a href="/privacy-policy" target="_blank">privacy policy</a>',
            contact_successfully: 'Message sent successfully',
            addAddress: 'Add address',
            home_first_description: '<strong>A private collection of international contemporary art</strong><br><br>A 3 hectares Sculpture Park placed in ancient olive groves & contemporary art gallery in the outskirts of the Ebro Delta\n',
            home_good_morning: 'Arte-Contemporary wishes you a good morning',
            home_good_afternoon: 'Arte-Contemporary wishes you a good afternoon',
            home_good_evening: 'Arte-Contemporary wishes you a good evening',
            suggested_route: 'Suggested route',
            credit_card_info: 'Credit Card Information',
            credit_card_privacy_policy: 'Your personal data will be used to process your order, support your experience throughout this website, and for other purposes described in our privacy policy.',
            payment_error: 'Payment Error',
            payment_successfuly: 'Successful Payment',
            404: 'Page not found',
            ShoppingCart: 'Shopping cart',
            FindUs: 'How to find us?',
            VideoTour: 'Video Tour',
            add_shopping_cart: 'Add to cart',
            prices: 'Prices',
            products: 'Products',
            invoices: 'Invoices',
            invoice: 'Invoice',
            copyright: '<strong>Copyright &copy; 2022 Arte-Contemporary.</strong> All rights reserved. - Design by <a href="https://www.hitech-informatica.es/" target="_blank">Hitech Informàtica</a>',
            advanced_products: 'Pre booked refreshments such as soft drinks, water, coffee or tea with a cake portion or another bite',
            title: 'Title',
            number_invoice: 'Invoice number',
            adminGDPR: 'General Data Protection Regulation',
            adminNewsletter: 'Send newsletter',
            min_places: 'Places (minimum)',
            max_places: 'Places (maximum)',
            places_discount: 'Places discount',
            discountcode: 'Discount code (optional)',
            discounttitle: 'Discount code',
            number_booking: 'Booking number',
            invoice_mail_error: "Error sending confirmation, you can download the documentation related to your profile",
            cookie_policy: 'Cookie Policy',
            cookies: 'Cookie Policy',
            image_grid: 'Image',
            cover_image: 'Cover image',
            external_link: 'External link',
            external_link_title: 'External link title',
            select: 'Select',
            enter_to_select: "Select",
            enter_to_select_group:"Select group",
            selected:'Selected',
            enter_to_deselect:"Deselect",
            enter_to_deselect_group:"Deselect group",
            options_selected: 'options selected',
            bookingsOfertaTitle: 'Special offer',
            add_or_select_invoice_address: 'Please add or select invoice address',
            add_or_select_delivery_address: 'Please add or select delivery address',
            successfully_updated:'Successfully updated',
            successfully_created:'Successfully created',
            full_name: 'Full name',
            modals: 'Pop-ups',
            modal: 'Pop-up',
            pages: 'Pages',
            content: 'Content',
            action: 'Action',
            action_title: 'Action title',
            sizes: 'Sizes',
            privacy_policy: 'Privacy policy. Purchase and returns conditions',
            reset_password: 'Reset password',
            send_reset_link: 'Send reset link',
            new_password: 'New password',
            reset_mail_send: 'You received email with link to set new password',
            legal_policy: 'Legal notice',
            gdpr: 'GDPR',
            newsletter: 'Newsletter',
            we_are_part: 'We are part',
            not_available_date_selected: 'There is no availability on the selected date',
            none: 'None',
            register_for_buy: 'Register to book your tickets',
            register_for_buy_artworks: "Register to buy artworks",
            home_bookings_t1: "Ticket reservation",
            home_bookings_p1: "Reserve your ticket and come visit our sculpture park and interior gallery",
            home_bookings_b1: 'Buy tickets',
            home_shopping_t1: 'Buy art',
            home_shopping_p1: "Would you like to purchase a work of art from our gallery?",
            home_shopping_b1: 'Buy art',
            home_exhibitions_t1: 'Exhibitions',
            home_exhibitions_p1: 'Consult our cultural program in the park and interior gallery',
            home_exhibitions_b1: 'Consult program',
            footer_call_action: 'Buy your ticket',
            contact: 'Contact',
            last_products: 'Last artworks',
            customer_data: 'Customer data',
            create_account: 'Create account?',
            delivery_different_address: 'Shop to a different address?',
            you_have_account: 'You have an account?',
            pay_now: 'Pay',
            add_your_name: 'Enter your full name',
            add_your_email: 'Enter your email',
            add_valid_email: 'You have not entered a valid email',
            sculpture_park: "The Sculpture Park",
            gallery: "Gallery",
            not_on_sale: "Not on sale",
            select_number_tickets: "Select the number of tickets",
            opening_times: "Opening hours",
            opening_times_p: "Thursdays: from 16:00h - 18:30h<br>Fridays: from 10:30h to 13:30h and from 16:00h to 18:30h<br>Weekends: from 10:30h to 13:30h",
            photography_competition: 'Photography contest',
            is_author: 'Is author?',
            author_label: 'Author',
            your_name: 'Your name',
            your_cog: 'Your last name',
            your_email: 'Your email',
            suscribe_newsletter: 'Subscribe to the newsletter',
            successfully_subscribed: 'Successfully subscribed',
            error_subscribed: 'Failed to subscribe',
            subscribe_title: 'SUBSCRIBE TO OUR NEWSLETTER',
            subscribe_content: "Follow us and catch up on all the news",
            accept_gdpr: 'You must accept the privacy policy',
            search: 'Search',
            clear: 'Reset filters',
            view_profile: 'View profile',
            follow_instagram: 'Follow on Instagram',
            whatsapp_contact: 'WhatsApp',
        }
    },
    es: {
        hi: {
            lang_name: 'Español',
            areYouSure: '¿Esta segur@?',
            book: 'Reserva',
            yes: 'Sí',
            no: 'No',
            create: 'Crear',
            edit: 'Editar',
            delete: 'Eliminar',
            socialNetworks: 'Redes sociales',
            socialNetworkFollow: 'Seguir en redes sociales:',
            siteName: 'Arte-contemporary',
            homeDescription: "Un parque de esculturas de 3 hectáreas entre olivares milenarios y una galería de arte contemporáneo de 300 m² en las afueras del Delta del Ebro",
            loginRegister: "Acceder o registrarse",
            name: 'Nombre',
            surname: 'Apellidos',
            email: 'Correo',
            password: 'Contraseña',
            phone: 'Teléfono',
            role: 'Rol',
            admin: 'Administrador',
            client: 'Cliente',
            icon: 'Icono',
            save: 'Guardar',
            roles: "Grupos de usuarios",
            authors: 'Artistas',
            socialNetwork: 'Red social',
            countries: 'Países',
            iso2: 'Iso2',
            url: 'URL',
            device_not_suport_uploading: '<p>Su dispositivo no admite la carga de archivos.</p>',
            drag_upload_image: 'Arrastre una imagen o <br>haga clic aquí para seleccionar un archivo',
            tap_upload_image: 'Toque aquí para seleccionar una foto <br>de su galería',
            change_image: 'Cambiar imagen',
            remove_image: 'Quitar imagen',
            select_image: 'Selecionar imagen',
            selected_image: '<p>¡Imagen seleccionada correctamente!</p>',
            error_filesize: 'El tamaño del archivo supera el límite.',
            error_filetype: 'Este tipo de archivo no es compatible.',
            aspect: 'Apaisada/Retrato',
            description: 'Descripción',
            type: 'Tipo',
            address: 'Dirección',
            zip_code: 'Código postal',
            city: 'Ciudad',
            region: 'Región',
            notes: 'Notas',
            user: 'Usuario',
            country: 'País',
            user_address_details: 'Detalles de la dirección',
            userAddresses: 'Direcciones de usuarios',
            userAddressType: 'Tipo de dirección',
            userAddressTypes: 'Tipos de direcciones',
            userAddressTypeInvoice: 'Dirección de facturación',
            userAddressTypeDelivery: 'Dirección de entrega',
            categories: 'Categorias',
            category: 'Categoria',
            artworks: 'Obras de arte',
            artwork: 'Piezas de arte',
            author: 'Artista',
            authorInfo_1: 'Información',
            authorInfo_2: 'del Artista',
            public: 'Es pública',
            on_sale: 'A la venta',
            taxes: 'Impuestos',
            tax: 'Impuesto',
            percent: 'Porcentaje',
            close: 'Cerrar',
            stock: 'Stock',
            price: 'Precio',
            amount: 'Total',
            image: 'Imagen',
            holidays: 'Festivos',
            holiday: 'Festivo',
            day_start: 'Día de inicio',
            month_start: 'Mes de inicio',
            year_start: 'Año de inicio',
            day_end: 'Dia final',
            month_end: 'Mes final',
            year_end: 'Año final',
            days_of_week: 'Días de la semana',
            exceptions: 'Excepciones',
            day: 'Dia',
            month: 'Mes',
            year: 'Año',
            time_slots: 'Franjas horarias',
            time_slot: 'Franja horaria',
            assistants: 'Asistentes',
            date_start: 'Fecha de inicio',
            date_end: 'Fecha final',
            time_start: 'Hora de inicio',
            time_end: 'Hora final',
            users: 'Usuarios',
            without_artworks: 'No hay obras para mostrar',
            related_artworks: 'Obras relacionadas',
            shoppingCart: 'Carrito de compra',
            cartProduct: 'Producto',
            cartPrice: 'Precio',
            cartQty: 'Cantidad',
            cartSubTotal: 'Subtotal',
            cartCheckout : 'Pago',
            cartComplete: 'Finalizar compra',
            cartTotals: 'Total Carrito',
            cartShipping: 'Tipo de envío',
            cartProceed: 'Ir al pago',
            cartCouponCode: 'Código cupón',
            cartCoupon: 'Aplicar cupón',
            cartUpdate: 'Actualizar carrito',
            cartTax: 'IVA',
            cartTotalTax: 'Total IVA',
            cartTotTot: 'Total',
            cartBooking: 'Reserva',
            cartPlaces: 'plaza(s)',
            addShoppingCart: 'Agregar al carrito',
            places_available: '{places} plazas disponibles',
            chkoutDetails: 'Datos de Facturación',
            chkoutName: 'Nombre completo',
            chkoutCompany: 'Compañía',
            chkoutCountry: 'País',
            chkoutCity: 'Población',
            chkoutZIP: 'Código Postal',
            chkoutEmail: 'Correo electrónico',
            chkoutPhoneNumber: 'Teléfono',
            chkoutAccount: '¿Crear una cuenta?',
            chkoutNotes: 'Observaciones',
            chkoutNotes2: 'Observaciones especiales sobre su compra ( condiciones de entrega, por ejemplo )',
            chkoutSelAddress: 'Agregar dirección de facturación',
            chkoutAddress: 'Dirección facturación',
            addAddress: 'Agregar dirección',
            chkoutSelShipAddress: 'Agregar dirección de envío',
            chkoutShipAddress: 'Dirección de envío',
            chkoutLogin: 'Antes de realizar su compra, es necesario crear una cuenta.',
            chkYourOrder: 'Su compra',
            chkoutResume: 'Resumen de productos',
            chkoutShipType: 'Tipo de Envío',
            chkoutPayment: 'Forma de Pago',
            chkoutPlaceOrder: 'Finalizar Compra',
            chkoutPassword: 'Contraseña',
            chkoutRemember: 'Recordarme en este equipo',
            chkoutForgot: '¿Olvidó su contraseña?',
            chkoutOr: 'o',
            chkoutFacebook: 'Logearse con Facebook',
            chkoutRegister: 'Registrarse',
            chkoutConfirm: 'Confirmar contraseña',
            chkoutModalShipTitle: 'Dirección de Envío',
            chkoutModalInvoiceTitle: 'Agregar Dirección de Facturación',
            chkoutModalInvTitle: 'Dirección de Facturación',
            chkoutInvoiceMandatory: 'Dirección de facturación obligatoria',
            chkoutDeliveryMandatory: 'Dirección de envío obligatoria',
            chkoutNews: 'Enviarme información sobre novedades, eventos y ofertas especiales de Arte-Contemporary',
            chkoutWithTax: '(IVA incluido)',
            chkoutWithoutTax: '(IVA no incluido)',
            cartAction: 'Acción',
            cartAlertTitle: 'Actualizar Carrito',
            cartAlertText: 'Actualización realizada correctamente',
            cartAlertCheck: 'Ir al pago',
            cartAlertCancel: 'Volver a la cesta',
            delivery_address: 'Dirección de entrega',
            delivery_zip: 'C.Postal',
            delivery_city: 'Población',
            delivery_region: 'Región',
            delivery_notes: 'Observaciones',
            tickets: 'Entradas',
            ticket: 'Entrada',
            book_your_tickets: 'Reserva de entradas',
            plan_visit_opening_times: 'Reservas',
            find_us: '¿Cómo llegar?',
            personalizables: 'Personalizables',
            rapita_ebro_delta: 'La Rápita y el Delta del Ebro',
            reservations_text: 'Texto Reserva de entradas',
            inicio_text: 'Texto de Inicio',
            RapitaEbroDelta: 'La Rápita y el Delta del Ebro',
            about: '¿Quieres saber un poco más?',
            video_tour: 'Video Tour',
            VideoTour: 'Video Tour',
            sculpture_park_gallery: 'Sobre el Parque de Esculturas y la Galería',
            SulptureParkGallery: 'Sobre el Parque de Esculturas y la Galería',
            exhibitions_events: 'Exhibiciones y eventos',
            current_exhibitions_cultural_program: 'Exhibiciones y Programa cultural',
            about_the_artists: 'Sobre los artistas',
            'purchasing_arte-pieces': 'Nuestra tienda',
            private_corporate_hire: 'Organiza tu evento',
            profilePageTitle: 'Perfil de Usuario',
            profileMenuGeneralData: 'Mi Perfil',
            profileMenuAddresses: 'Mis direcciones',
            profileMenuShipping: 'Mis direcciones envíos',
            profileMenuInvoices: 'Mis direcciones facturas',
            profileFormName: 'Nombre completo',
            profileFormEmail: 'Email',
            profileFormPhone: 'Teléfono',
            profileFormActualPass: 'Contraseña Actual',
            profileFormPassword: 'Nueva Contraseña',
            profileFormConfirm: 'Confirmar contraseña',
            profileFormSave: 'Guardar',
            profileShipAddress: 'Direcciones de envío',
            profileInvoiceAddress: 'Direcciones de facturación',
            profileEdit: 'Editar',
            profileDelete: 'Eliminar',
            profileAddAddress: 'Agregar Dirección',
            profileTabProfile: 'Mi Perfil',
            profileTabShipping: 'Mis direcciones de envío',
            profileTabInvoice: 'Mis direcciones de facturación',
            profileTabPassword: 'Modificar contraseña',
            profileTabMyInvoices: 'Mis compras',
            profileInvoiceNumber: 'Factura número',
            profileInvoiceDate: 'Fecha',
            profileInvoiceTotal: 'Importe',
            profileInvoiceDownload: 'Descargar ',
            confirm_password: 'Confirmar contraseña',
            confirm_shopping_cart: 'Activar "Confirmar carrito" en el proceso de compra',
            home:'Inicio',
            contactTitle: 'Contactar',
            contactName: 'Nombre Completo',
            contactEmail: 'Email',
            contactPhoneNumber: 'Teléfono de contacto',
            contactSubject: 'Asunto',
            contactMessage: 'Mensaje',
            contactSend: 'Enviar Mensaje',
            contactSuccess: '¡Mensaje Enviado!',
            contactSuccessMsg: 'Su mensaje se ha enviado correctamente.',
            contactError: '!Error¡',
            contactErrorMsg: 'Ocurrió un error al enviar su mensaje.',
            contactHours: 'Horario comercial',
            contactHoursDays: 'Miércoles a Domingo de 9:00h a 14:00h',
            contactTouch: 'Contáctenos',
            contactTouchMsg: 'Contacte con nosotros, estamos a su disposición para cualquier duda, consulta o aclaración que desee hacer.',
            contactUs: 'Contáctanos',
            footerMap: 'Mapa de Localización',
            footerCopy: 'Todos los derechos reservados.',
            Contact: 'Contactar',
            UserProfile: 'Perfil de Usuario',
            CheckoutCart: 'Checkout',
            login_or_register: 'Entrar o registrarse',
            date: 'Fecha',
            view_shoppingcart: 'Ver carrito',
            checkout: 'Verificación y pago',
            contactUsTitle: 'Contáctanos',
            shoppingCarts: 'Carritos',
            order_number: 'Número de pedido',
            status: 'Estatus',
            booking: 'Reserva',
            bookings: 'Reservas',
            items: 'Ítems',
            units: 'Unidades',
            read_more: 'Leer más',
            processing: 'Procesando',
            new: 'Nuevo',
            confirmed: 'Confirmado',
            paid: 'Pagado',
            cancelled: 'Cancelado',
            abandoned: 'Abandonado',
            make_invoice: 'Crear factura',
            invoice_address: 'Dirección de facturación',
            view_all: 'Ver todo',
            share: 'Compartir',
            artworkDetails: 'Detalles de la obra',
            time: 'Tiempo',
            admin_panel: 'Panel de Administración',
            unknown_error: 'Error desconocido',
            user_password_error: 'Email o contraseña incorrectos',
            thank_you_order_received: '¡Muchas gracias! Compra realizada correctamente.',
            total: 'Total',
            payment_method: 'Forma de pago',
            credit_card: 'Tarjeta de crédito',
            your_order: 'Resumen de su compra',
            product: 'Producto',
            subtotal: 'Subtotal',
            shipping: 'Envío',
            shippingFree: 'Gratis',
            CompleteCart: 'Finalizar compra',
            personal_data_usage: 'Sus datos personales serán usados para mejorar su experiencia a través de esta página, para manejar su cuenta y para otros propósitos descritos en nuestra <a href="#" class="text-decoration-none">política de privacidad</a>.',
            register: 'Registrarse',
            contactHoursTime: '9h a 20h',
            location: '40°38\'07.2"N 0°35\'03.2"E, Sant Carles de la Ràpita, Tarragona',
            info_mail: 'info@arte-contemporary.eu',
            corporate_mail: 'corporate@arte-contemporary.eu',
            starterPages: 'Páginas iniciales',
            activePage: 'Página activa',
            inactivePage: 'Página inactiva',
            simpleLink: 'Link simple',
            remember_me: 'Recuérdame',
            forgot_password: 'Olvidé la contraseña',
            login: 'Entrar',
            password_confirmation: 'Confirmar la contraseña',
            dates_ft: 'Visitar desde el {from} hasta el {to}',
            view_more: 'Ver más',
            exhibitions: 'Exhibiciones',
            plan_visit: 'Planea tu visita',
            rentParkTitle: '¿Quieres organizar tu evento único y memorable en Arte-Contemporary? ',
            phone_number: 'Teléfono',
            website: 'Página web',
            start: 'Inicio',
            end: 'Fin',
            active: 'Activo',
            timeSlots: 'Franjas horarias',
            timeSlot: 'Franja horaria',
            rent_park: 'Organiza tu evento',
            results_not_found: 'No se han encontrado resultados',
            go_back: 'Ir atrás',
            add: 'Añadir',
            gdpr_accept_policy: 'He leído y acepto la <a href="/privacy-policy" target="_blank">política de privacidad</a>',
            contact_successfully: 'Mensaje enviado correctamente',
            suggested_route: 'Ruta sugerida',
            home_first_description: '<strong>Una colección privada de arte contemporáneo internacional</strong><br><br>Parque de esculturas en una finca de olivos de 3 hectáreas y galería de arte contemporáneo en el Delta del Ebro',
            home_good_morning: 'Arte-Contemporary les desea un buen día',
            home_good_afternoon: 'Arte-Contemporary les desea buenas tardes',
            home_good_evening: 'Arte-Contemporary les desea una buena tarde',
            PDFinvoice: 'Factura',
            credit_card_info: 'Información de la tarjeta',
            credit_card_privacy_policy: 'Sus datos personales serán usados para procesar su pedido, mejorar su experiencia en esta página, y para otros propósitos descritos en nuestra política de privacidad.',
            payment_error: 'Error de Pago',
            payment_successfuly: 'Pago realizado correctamente',
            404: 'Página no encontrada',
            ShoppingCart: 'Carrito de compra',
            FindUs: '¿Cómo llegar?',
            ideoTour: 'Vídeo Tour',
            add_shopping_cart: 'Agregar al carrito',
            prices: 'Precios',
            products: 'Productos',
            invoices: 'Facturas',
            invoice: 'Factura',
            copyright: '<strong>Copyright &copy; 2022 Arte-Contemporary.</strong> Todos los derechos reservados. - Diseño web <a href="https://www.hitech-informatica.es/" target="_blank">Hitech Informàtica</a>',
            advanced_products: 'Puede reservar con antelación refrescos, agua, café o té con una porción de pastel u otro bocado',
            title: 'Título',
            number_invoice: 'Número de factura',
            adminGDPR: 'Reglamento General de Protección de Datos',
            adminNewsletter: 'Enviar newsletter',
            min_places: 'Lugares (mínimo)',
            max_places: 'Lugares (máximo)',
            places_discount: 'Descuento lugares',
            discountcode: 'Código de descuento (Opcional)',
            discounttitle: 'Código de descuento',
            number_booking: 'Número de reserva',
            invoice_mail_error: "Error al enviar la confirmación, puede descargar la documentación relacionada en su perfil",
            cookie_policy: 'Política de Cookies',
            cookies: 'Política de Cookies',
            image_grid: 'Imagen',
            cover_image: 'Imagen de portada',
            external_link: 'Enlace relacionado',
            external_link_title: 'Titulo del enlace relacionado',
            select: 'Seleccionar',
            enter_to_select: "Seleccionar",
            enter_to_select_group:"Seleccionar grupo",
            selected:'Seleccionado',
            enter_to_deselect:"Quitar",
            enter_to_deselect_group:"Quitar grupo",
            options_selected: 'opciones selecionadas',
            bookingsOfertaTitle: 'Oferta especial',
            add_or_select_invoice_address: 'Agregue o seleccione la dirección de facturación',
            add_or_select_delivery_address: 'Por favor agregue o seleccione la dirección de entrega',
            successfully_updated:'Modificado correctamente',
            successfully_created:'Añadido correctamente',
            full_name: 'Nombre completo',
            modals: 'Ventanas emergentes',
            modal: 'Ventana emergente',
            pages: 'Páginas',
            content: 'Contenido',
            action: 'Acción',
            action_title: 'Título dela acción',
            sizes: 'Medidas',
            privacy_policy: 'Protección de datos y política de compras y devoluciones',
            reset_password: 'Restablecer la contraseña',
            send_reset_link: 'Enviar enlace',
            new_password: 'Nueva contraseña',
            reset_mail_send: 'Recibiste un correo electrónico con un enlace para establecer una nueva contraseña',
            legal_policy: 'Aviso legal',
            gdpr: 'GDPR',
            newsletter: 'Newsletter',
            we_are_part: 'Formamos parte',
            not_available_date_selected: 'No hay disponibilidad en la fecha seleccionada',
            none: 'Ninguna',
            register_for_buy: 'Regístrese para reservar las entradas',
            register_for_buy_artworks: 'Regístrese para comprar piezas de arte',
            home_bookings_t1: 'Reserva de entradas',
            home_bookings_p1: 'Reserva tu entrada y ven a visitar nuestro parque de esculturas y galería interior ',
            home_bookings_b1: 'Compra entradas',
            home_shopping_t1: 'Comprar arte',
            home_shopping_p1: '¿Te gustaría adquirir una obra de arte de nuestra galería? ',
            home_shopping_b1: 'Compra arte',
            home_exhibitions_t1: 'Exhibiciones',
            home_exhibitions_p1: 'Consulta nuestro programa cultural en el parque y galería interior ',
            home_exhibitions_b1: 'Consulta programa',
            footer_call_action: 'Compra tu entradas',
            contact: 'Contacto',
            last_products: 'Últimas obras de arte',
            customer_data: 'Datos personales',
            create_account: '¿Crear una cuenta?',
            delivery_different_address: '¿Entregar a una dirección distinta?',
            you_have_account: '¿Tienes una cuenta?',
            pay_now: 'Pagar',
            add_your_name: 'Introduce tu nombre completo',
            add_your_email: 'Introduce tu correo electrónico',
            add_valid_email: 'No has introducido un correo electrónico valido',
            sculpture_park: "El Parque de Esculturas",
            gallery: "Galeria",
            not_on_sale: "No se vende",
            select_number_tickets: "Seleccione el número de entradas",
            opening_times: "Horario de apertura",
            opening_times_p: "Jueves: de 16:00h a 18:30h<br>Viernes: de 10:30h a 13:30h i de 16:00h a 18:30h<br>Fines de setmana: de 10:30h a 13:30h",
            photography_competition: 'Concurso de fotografía',
            is_author: '¿Es autor?',
            author_label: 'Autor',
            your_name: 'Tu nombre',
            your_cog: 'Tu apellido',
            your_email: 'Tu email',
            suscribe_newsletter: 'Suscríbete al newsletter',
            successfully_subscribed: 'Suscrito correctamente',
            error_subscribed: 'Error al suscribirse',
            subscribe_title: 'SUSCRÍBETE A NUESTRA NEWSLETTER',
            subscribe_content: "Síguenos y ponte al día de todas las novedades",
            accept_gdpr: 'Es necesario aceptar la política de privacidad',
            search: 'Buscar',
            clear: 'Reiniciar filtros',
            view_profile: 'Ver Perfil',
            follow_instagram: 'Seguir en Instagram',
            whatsapp_contact: 'WhatsApp',
        }
    },
    ca: {
        hi: {
            lang_name: 'Català',
            areYouSure: 'Està segur?',
            book: 'Reserva',
            yes: 'Sí',
            no: 'No',
            create: 'Crear',
            edit: 'Editar',
            delete: 'Eliminar',
            socialNetworks: 'Xarxes socials',
            socialNetworkFollow: 'Seguir a les xarxes socials:',
            siteName: 'Arte-contemporary',
            homeDescription: "Un parc d'escultures de 3 hectàrees entre oliveres milenàries i una galeria d'art contemporani de 300 m² a les afores del Delta de l'Ebre",
            loginRegister: "Accedir o registrar-se",
            name: 'Nom',
            surname: 'Cognoms',
            email: 'Correu',
            password: 'Contrasenya',
            phone: 'Telèfon',
            role: 'Rol',
            admin: 'Administrador',
            client: 'Client',
            icon: 'Icona',
            save: 'Guardar',
            roles: "Grups d'usuaris",
            authors: 'Artistes',
            socialNetwork: 'Xarxa social',
            countries: 'Països',
            iso2: 'Iso2',
            url: 'URL',
            device_not_suport_uploading: '<p>El seu dispositiu no admet la càrrega de fitxers.</p>',
            drag_upload_image: 'Arrossegui una imatge o <br>faci clic aquí per seleccionar un fitxer',
            tap_upload_image: 'Toqui aquí per seleccionar una foto <br>de la seva galeria',
            change_image: 'Canviar imatge',
            remove_image: 'Treure imatge',
            select_image: 'Seleccionar imatge',
            selected_image: '<p>Imatge seleccionada correctament!</p>',
            error_filesize: 'La mida del fitxer supera el límit.',
            error_filetype: 'Aquest tipus de fitxer no és compatible.',
            aspect: 'Apaïsada/Retrat',
            description: 'Descripció',
            type: 'Tipus',
            address: 'Adreça',
            zip_code: 'Codi postal',
            city: 'Ciutat',
            region: 'Regió',
            notes: 'Notes',
            user: 'Usuari',
            country: 'País',
            user_address_details: 'Detalls de l\'adreça',
            userAddresses: 'Adreces d\'usuaris',
            userAddressType: 'Tipus d\'adreça',
            userAddressTypes: 'Tipus d\'adreces',
            userAddressTypeInvoice: 'Adreça de facturació',
            userAddressTypeDelivery: 'Adreça d\'entrega',
            categories: 'Categories',
            category: 'Categoria',
            artworks: 'Obres d\'art',
            artwork: 'Peces d\'art',
            author: 'Artista',
            authorInfo_1: 'Informació',
            authorInfo_2: 'de l\'artista',
            public: 'És pública',
            on_sale: 'A la venda',
            taxes: 'Impostos',
            tax: 'Impost',
            percent: 'Percentatge',
            close: 'Tancar',
            stock: 'Estoc',
            price: 'Preu',
            amount: 'Total',
            image: 'Imatge',
            holidays: 'Festius',
            holiday: 'Festiu',
            day_start: 'Dia d\'inici',
            month_start: 'Mes d\'inici',
            year_start: 'Any d\'inici',
            day_end: 'Dia final',
            month_end: 'Mes final',
            year_end: 'Any final',
            days_of_week: 'Dies de la setmana',
            exceptions: 'Excepcions',
            day: 'Dia',
            month: 'Mes',
            year: 'Any',
            time_slots: 'Franges horàries',
            time_slot: 'Franja horària',
            assistants: 'Assistents',
            date_start: 'Data d\'inici',
            date_end: 'Data final',
            time_start: 'Hora d\'inici',
            time_end: 'Hora final',
            users: 'Usuaris',
            without_artworks: 'No hi ha obres per mostrar',
            related_artworks: 'Obres relacionades',
            shoppingCart: 'Carretó de compra',
            cartProduct: 'Producte',
            cartPrice: 'Preu',
            cartQty: 'Quantitat',
            cartSubTotal: 'Subtotal',
            cartCheckout : 'Checkout',
            cartComplete: 'Finalitzar compra',
            cartTotals: 'Total Carretó',
            cartShipping: 'Tipus d\'enviament',
            cartProceed: 'Anar al pagament',
            cartCouponCode: 'Codi cupó',
            cartCoupon: 'Aplicar cupó',
            cartUpdate: 'Actualitzar cistella',
            cartTax: 'IVA',
            cartTotalTax: 'Total IVA',
            cartTotTot: 'Total',
            cartBooking: 'Reserva',
            cartPlaces: 'plaça/ces',
            addShoppingCart: 'Afegir al cistella',
            places_available: '{places} places disponibles',
            chkoutDetails: 'Dades de facturació',
            chkoutName: 'Nom complet',
            chkoutCompany: 'Companyia',
            chkoutCountry: 'País',
            chkoutCity: 'Població',
            chkoutZIP: 'Codi Postal',
            chkoutEmail: 'Correu electrònic',
            chkoutPhoneNumber: 'Telèfon',
            chkoutAccount: 'Crear un compte?',
            chkoutNotes: 'Observacions',
            chkoutNotes2: 'Observacions especials sobre la seva compra ( condicions d\'entrega, per exemple )',
            chkoutSelAddress: 'Afegir adreça de facturació',
            chkoutAddress: 'Adreça facturació',
            chkoutSelShipAddress: 'Afegir adreça d\'enviament',
            chkoutShipAddress: 'Adreça d\'enviament',
            chkoutLogin: 'Abans de realitzar la seva compra és necessari crear un compte.',
            chkYourOrder: 'La seva compra',
            chkoutResume: 'Resum de productes',
            chkoutShipType: 'Tipus d\'enviament',
            chkoutPayment: 'Forma de Pagament',
            chkoutPlaceOrder: 'Finalitzar Compra',
            chkoutPassword: 'Contrasenya',
            chkoutRemember: 'Recordar-me en aquest equip',
            chkoutForgot: 'Ha oblidat la seva contrasenya?',
            chkoutOr: 'o',
            chkoutFacebook: 'Entrar amb Facebook',
            chkoutRegister: 'Registrar-se',
            chkoutConfirm: 'Confirmar contrasenya',
            chkoutModalShipTitle: 'Adreça d\'enviament',
            chkoutModalInvoiceTitle: 'Afegir adreça de facturació',
            chkoutModalInvTitle: 'Adreça de facturació',
            chkoutInvoiceMandatory: 'Adreça de facturació obligatòria',
            chkoutDeliveryMandatory: 'Direcció d\'enviament obligatori',
            chkoutNews: 'Envia informació sobre novetats, esdeveniments i ofertes especials d\'Arte-Contemporary',
            chkoutWithTax: '(IVA inclòs)',
            chkoutWithoutTax: '(IVA no inclòs)',
            cartAction: 'Acció',
            cartAlertTitle: 'Actualitzar cistella',
            cartAlertText: 'Actualització realitzada correctament',
            cartAlertCheck: 'Anar al pagament',
            cartAlertCancel: 'Tornar a la cistella',
            delivery_address: "Adreça de lliurament",
            delivery_zip: 'C.Postal',
            delivery_city: 'Població',
            delivery_region: 'Regió',
            delivery_notes: 'Observacions',
            tickets: 'Entrades',
            ticket: 'Entrada',
            book_your_tickets: 'Reserva les teves entrades',
            plan_visit_opening_times: 'Reserves',
            find_us: 'Com arribar-hi?',
            personalizables: 'Personalitzables',
            rapita_ebro_delta: 'La Ràpita i el Delta de l\'Ebre',
            reservations_text: 'Text Reserva d\'entrades',
            inicio_text: 'Text d\'Inici',
            RapitaEbroDelta: 'La Ràpita i el Delta de l\'Ebre',
            about: 'Sobre nosaltres',
            video_tour: 'Video Tour',
            sculpture_park_gallery: 'Sobre el parc d\'escultures i la galeria',
            SulptureParkGallery: 'Sobre el parc d\'escultures i la galeria',
            exhibitions_events: 'Exposicions y Esdeveniments',
            current_exhibitions_cultural_program: 'Exposicions i Programa cultural',
            about_the_artists: 'Sobre els artistes',
            'purchasing_arte-pieces': 'La nostra Tenda',
            private_corporate_hire: 'Organitza el teu esdeveniment',
            profilePageTitle: 'Perfil d\'Usuari',
            profileMenuGeneralData: 'El meu Perfil',
            profileMenuAddresses: 'Les meves adreces',
            profileMenuShipping: 'Les meves adreces d\'enviament',
            profileMenuInvoices: 'Les meves adreces de facturació',
            profileFormName: 'Nom complet',
            profileFormEmail: 'Email',
            profileFormPhone: 'Telèfon',
            profileFormActualPass: 'Contrasenya Actual',
            profileFormPassword: 'Nova Contrasenya',
            profileFormConfirm: 'Confirmar contrasenya',
            profileFormSave: 'Guardar',
            profileShipAddress: 'Adreces d\'enviament',
            profileInvoiceAddress: 'Adreces de facturació',
            profileEdit: 'Editar',
            profileDelete: 'Eliminar',
            profileAddAddress: 'Afegir Direcció',
            profileTabProfile: 'El meu Perfil',
            profileTabShipping: 'Les meves adreces d\'enviament',
            profileTabInvoice: 'Les meves adreces de facturació',
            profileTabMyInvoices: 'Les meves compres',
            profileTabPassword: 'Modificar contrasenya',
            profileInvoiceNumber: 'Factura número',
            profileInvoiceDate: 'Data',
            profileInvoiceTotal: 'Import',
            profileInvoiceDownload: 'Descarregar',
            confirm_password: 'Confirmar contrasenya',
            confirm_shopping_cart: 'Activar "Confirmar cistella" al procés de compra',
            home:'Inici',
            contactTitle: 'Contactar',
            contactName: 'Nom Complet',
            contactEmail: 'Email',
            contactPhoneNumber: 'Telèfon de contacte',
            contactSubject: 'Assumpte',
            contactMessage: 'Missatge',
            contactSend: 'Enviar Missatge',
            contactSuccess: 'Missatge Enviat!',
            contactSuccessMsg: 'El seu missatge s\'ha enviat correctament.',
            contactError: 'Error!',
            contactErrorMsg: 'Ha ocorregut un error a l\'enviar el seu missatge.',
            contactHours: 'Horari comercial',
            contactHoursDays: 'De dimecres a diumenge de 9:00h a 14:00h',
            contactTouch: 'Contacti\'ns',
            contactTouchMsg: 'Contacti amb nosaltres, estem a la seva disposició per qualsevol dubte, consulta o aclariment que necessiti.',
            contactUs: 'Contacta\'ns',
            footerMap: 'Mapa de Localització',
            footerCopy: 'Tots els drets reservats.',
            Contact: 'Contactar',
            UserProfile: 'Perfil d\'Usuari',
            CheckoutCart: 'Checkout',
            login_or_register: 'Entrar o registrar-se',
            date: 'Data',
            view_shoppingcart: 'Veure cistella',
            checkout: 'Verificaciò i pagament',
            contactUsTitle: 'Contacta\'ns',
            shoppingCarts: 'Carretons',
            order_number: 'Número de comanda',
            status: 'Estatus',
            bookings: 'Reserves',
            booking: 'Reserva',
            items: 'Ítems',
            units: 'Unitats',
            read_more: 'Llegir més',
            processing: 'Processant',
            new: 'Nou',
            confirmed: 'Confirmat',
            paid: 'Pagat',
            cancelled: 'Cancel·lat',
            abandoned: 'Abandonat',
            make_invoice: 'Crear factura',
            invoice_address: 'Adreça de facturació',
            view_all: 'Veure tot',
            share: 'Compartir',
            artworkDetails: 'Detalls de l\'obra',
            time: 'Temps',
            admin_panel: 'Panell d\'Administració',
            unknown_error: 'Error desconegut',
            user_password_error: 'Email o contrasenya incorrectes',
            personal_data_usage: 'Les seves dades personals seran usades per tal de millorar la seva experiència a través d\'aquesta pàgina, per administrar el seu compte i per altres propòsits descrits a la nostra <a href="#" class="text-decoration-none">política de privadesa</a>.',
            register: 'Registrar-se',
            contactHoursTime: '9h a 20h',
            location: '40°38\'07.2"N 0°35\'03.2"E, Sant Carles de la Ràpita, Tarragona',
            info_mail: 'info@arte-contemporary.eu',
            corporate_mail: 'corporate@arte-contemporary.eu',
            starterPages: 'Pàgines inicials',
            activePage: 'Pàgina activa',
            inactivePage: 'Pàgina inactiva',
            simpleLink: 'Link simple',
            remember_me: 'Recorda\'m',
            forgot_password: 'He oblidat la contrasenya',
            login: 'Entrar',
            password_confirmation: 'Confirmar la contrasenya',
            dates_ft: 'Visitar des del {from} fins al {to}',
            view_more: 'Veure més',
            exhibitions: 'Exhibicions',
            plan_visit: 'Planeja la teva visita',
            rentParkTitle: '¿Vols organitzar un esdeveniment únic i memorable a Arte-Contemporary?',
            phone_number: 'Telèfon',
            website: 'Pàgina web',
            start: 'Inici',
            end: 'Fi',
            active: 'Actiu',
            timeSlots: 'Franges horàries',
            timeSlot: 'Franja horaria',
            rent_park: 'Organitza el teu esdeveniment',
            results_not_found: 'No s\'han trobat resultats',
            go_back: 'Anar enrere',
            add: 'Afegir',
            gdpr_accept_policy: 'He llegit i accepto la <a href="/privacy-policy" target="_blank">política de privadesa</a>',
            contact_successfully: 'Missatge enviat correctament',
            suggested_route: 'Ruta suggerida',
            addAddress: 'Afegir adreça',
            home_first_description: '<strong>Una col·lecció privada d\'art contemporani internacional.</strong><br><br>Som un parc d\'escultures i galeria d\'art contemporani situats en una finca d\'oliveres de 3 hectàrees al Delta de l\'Ebre.',
            home_good_morning: 'Arte-Contemporary us desitja un bon dia',
            home_good_afternoon: 'Arte-Contemporary us desitja una bona tarda',
            home_good_evening: 'Arte-Contemporary us desitja una bona tarda',
            PDFinvoice: 'Factura',
            credit_card_info: 'Informació de la targeta',
            credit_card_privacy_policy: 'Les vostres dades personals seran usades per processar la comanda, millorar la vostra experiència en aquesta pàgina, i per altres propòsits descrits a la nostra política de privacitat.',
            payment_error: 'Error de Pagament',
            payment_successfuly: 'Pagament realitzat correctament',
            404: 'Pàgina no trobada',
            ShoppingCart: 'Carret de compra',
            FindUs: 'Com arribar-hi?',
            add_shopping_cart: 'Afegeix a la cistella',
            bookingsTitle: 'Planeja la teva visita',
            CompleteCart: 'Finalitzar compra',
            VideoTour: 'Vídeo Tour',
            prices: 'Preus',
            products: 'Productes',
            invoices: 'Factures',
            invoice: 'Factura',
            copyright: '<strong>Copyright &copy; 2022 Arte-Contemporary.</strong> Tots els drets reservats.- Disseny web <a href="https://www.hitech-informatica.es/" target="_blank">Hitech Informàtica</a>',
            advanced_products: 'Reservar amb antelació refrescos, aigua, cafè o te amb una porció de pastís o un altre mos',
            title: 'Títol',
            number_invoice: 'Número de factura',
            adminGDPR: 'Reglament General de Protecció de Dades',
            adminNewsletter: 'Enviar newsletter',
            min_places: 'Llocs (mínim)',
            max_places: 'Llocs (màxim)',
            places_discount: 'Descompte llocs',
            discountcode: 'Codi de descompte (opcional)',
            discounttitle: 'Codi de descompte',
            number_booking: 'Número de reserva',
            invoice_mail_error: "Error al enviar la confirmació, podeu descarregar la documentació relacionada al vostre perfil",
            cookie_policy: 'Política de Cookies',
            cookies: 'Política de Cookies',
            image_grid: 'Imatge',
            cover_image: 'Imatge de portada',
            external_link: 'Enllaç relacionat',
            external_link_title: "Títol de l'enllaç relacionat",
            select: 'Seleccionar',
            enter_to_select: "Seleccionar",
            enter_to_select_group:"Seleccionar grup",
            selected:'Seleccionat',
            enter_to_deselect:"Treure",
            enter_to_deselect_group:"Treure grup",
            options_selected: 'opcions selecionades',
            bookingsOfertaTitle: 'Oferta especial',
            add_or_select_invoice_address: "Afegiu o seleccioneu l'adreça de facturació",
            add_or_select_delivery_address: "Si us plau, afegiu o seleccioneu l'adreça de lliurament",
            successfully_updated:'Modificat correctament',
            successfully_created:'Afegit correctament',
            full_name: 'Nom complet',
            modals: 'Finestres emergents',
            modal: 'Finestra emergent',
            pages: 'Pàgines',
            content: 'Contingut',
            action: 'Acció',
            action_title: "Títol de l'acció",
            thank_you_order_received: 'Moltes gracies! Compra realizada correctament.',
            sizes: 'Mesures',
            privacy_policy: 'Protecció de dades i política de devolucions',
            reset_password: 'Restablir la contrasenya',
            send_reset_link: "Enviar l'enllaç de restabliment",
            new_password: 'Nova contrasenya',
            reset_mail_send: 'Heu rebut un correu electrònic amb un enllaç per establir una nova contrasenya',
            legal_policy: 'Avís legal',
            gdpr: 'GDPR',
            newsletter: 'Newsletter',
            we_are_part: 'Formem part',
            not_available_date_selected: 'No hi ha disponibilitat a la data seleccionada',
            none: 'Cap',
            register_for_buy: 'Registrat per reservar les teves entrades',
            register_for_buy_artworks: "Registrat per comprar peces d'arte",
            home_bookings_t1: "Reserva d'entrades",
            home_bookings_p1: "Reserva la teva entrada i vine a visitar el nostre parc d´escultures i galeria interior",
            home_bookings_b1: 'Compra entrades',
            home_shopping_t1: 'Comprar art',
            home_shopping_p1: "T'agradaria adquirir una obra d'art de la nostra galeria?",
            home_shopping_b1: 'Compra art',
            home_exhibitions_t1: 'Exhibicions',
            home_exhibitions_p1: 'Consulta el nostre programa cultural al parc i galeria interior',
            home_exhibitions_b1: 'Consulta programa',
            footer_call_action: 'Compra les teves entrades',
            contact: 'Contacte',
            last_products: "Últimes obres d'art",
            customer_data: 'Dades personals',
            create_account: 'Crear un compte?',
            delivery_different_address: 'Entregar a una adreça diferent?',
            you_have_account: 'Tens un compte?',
            pay_now: 'Pagar',
            add_your_name: 'Introdueix el teu nom complet',
            add_your_email: 'Introdueix el teu correu electrònic',
            add_valid_email: 'No has introduït un correu electrònic vàlid',
            sculpture_park: "El Parc d’Escultures",
            gallery: "Galeria",
            not_on_sale: "No es ven",
            select_number_tickets: "Selecciona el nombre d'entrades",
            opening_times: "Horari d'obertura",
            opening_times_p: "Dijous: de 16:00h a 18:30h<br>Divendres: de 10:30h a 13:30h i de 16:00h a 18:30h<br>Caps de setmana: de 10:30h a 13:30h",
            photography_competition: 'Concurs de fotografia',
            is_author: 'És autor?',
            author_label: 'Autor',
            your_name: 'El teu nom',
            your_cog: 'El teu cognom',
            your_email: 'El teu email',
            suscribe_newsletter: 'Subscriu-te al newsletter',
            successfully_subscribed: 'Subscrit correctament',
            error_subscribed: "Error al subscriure's",
            subscribe_title: 'SUBSCRIU-TE A LA NOSTRA NEWSLETTER',
            subscribe_content: "Segueix-nos i posa't al dia de totes les novetats",
            accept_gdpr: 'Cal acceptar la política de privacitat',
            search: 'Buscar',
            clear: 'Reiniciar filtres',
            view_profile: 'Veure perfil',
            follow_instagram: 'Seguir a Instagram',
            whatsapp_contact: 'WhatsApp',
        }
    }
}
